import { render } from "./PageCollection.vue?vue&type=template&id=e3b63af6"
import script from "./PageCollection.vue?vue&type=script&lang=js"
export * from "./PageCollection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__